import { BANNER_SERVICE } from 'src/envVariables';
import { FullParams, GridBanner, Params } from './types';

const getBanner = async ({ idx = 1, slug, url }: FullParams) => {
  url.searchParams.append('idx', String((idx || 1) - 1));
  url.searchParams.append('type', slug === 'home' ? 'home' : 'category');
  url.searchParams.append('path', slug);

  try {
    const json = await fetch(url)
      .then((res) => (res.ok ? Promise.resolve(res) : Promise.reject(res)))
      .then((r) => r.json());

    return json as GridBanner[];
  } catch {
    return [];
  }
};

/** More info about api - https://gitlab.com/aaa-gth/ecommerce/platform/frontend/eis-category-banners */
export const getPageBannersBackend = async ({ idx = 1, slug }: Params) => {
  if (!BANNER_SERVICE) {
    console.error('BANNER_SERVICE env variable missed');

    return [];
  }
  const json = await getBanner({
    idx,
    slug,
    url: new URL(`${BANNER_SERVICE}/api/banner/section`),
  });

  return json;
};

/** More info about api - https://gitlab.com/aaa-gth/ecommerce/platform/frontend/eis-category-banners */
export const getPageBannersClient = async ({ idx = 1, slug }: Params) => {
  const json = await getBanner({
    idx,
    slug,
    url: new URL(`/api/services/banner/section`, window.location.origin),
  });

  return json;
};
